module.exports = __webpack_public_path__ + "img/Gold.20e548a5.svg";